import React from 'react'
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@mui/material'
import PropTypes from 'prop-types'

export default function ViewQuotationModal(props) {
  const { quotationDetails, isQuotationModalOpen, setIsQuotationModalOpen } =
    props

  const getTotalCost = () => {
    let total = 0
    quotationDetails.items.forEach((item) => {
      total += item.quantity * item.price
    })
    return total
  }
  return (
    <>
      <Dialog
        open={isQuotationModalOpen}
        onClose={() => setIsQuotationModalOpen(false)}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
        data-cy='quotationDialog'
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <DialogTitle>Quotation</DialogTitle>
          <DialogContent>
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Name</TableCell>
                    <TableCell>Quantity</TableCell>
                    <TableCell>Price</TableCell>
                    <TableCell>Description</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {quotationDetails.items.map((row) => (
                    <TableRow
                      key={row.name}
                      sx={{
                        '&:last-of-type td, &:last-of-type th': { border: 0 }
                      }}
                    >
                      <TableCell component='th' scope='row'>
                        {row.name}
                      </TableCell>
                      <TableCell align='right'>{row.quantity}</TableCell>
                      <TableCell align='right'>{row.price}</TableCell>
                      <TableCell align='right'>{row.desc}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <Box display='flex' flexDirection='row-reverse'>
              <Typography>Total ($): {getTotalCost()}</Typography>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button
              variant='contained'
              onClick={() => setIsQuotationModalOpen(false)}
              data-cy='closeDialogBtn'
            >
              Close
            </Button>
          </DialogActions>
        </Box>
      </Dialog>
    </>
  )
}

ViewQuotationModal.propTypes = {
  quotationDetails: PropTypes.object,
  isQuotationModalOpen: PropTypes.bool,
  setIsQuotationModalOpen: PropTypes.func
}
